/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Sweet_OptimalInputs */

const en_coach_sweet_optimal = /** @type {(inputs: Coach_Sweet_OptimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have been training hard recently and your body is adapting. This is a good place to be — your fitness is growing. Just make sure you are sleeping well and eating enough to support recovery.`)
};

const de_coach_sweet_optimal = /** @type {(inputs: Coach_Sweet_OptimalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast zuletzt hart trainiert, und dein Körper passt sich an. Guter Punkt — die Fitness wächst. Achte auf genug Schlaf und gute Ernährung, damit die Erholung mitkommt.`)
};

/**
* | output |
* | --- |
* | "You have been training hard recently and your body is adapting. This is a good place to be — your fitness is growing. Just make sure you are sleeping well an..." |
*
* @param {Coach_Sweet_OptimalInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_sweet_optimal = /** @type {((inputs?: Coach_Sweet_OptimalInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Sweet_OptimalInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_sweet_optimal(inputs)
	return de_coach_sweet_optimal(inputs)
});